import { storeFreeze } from 'ngrx-store-freeze';

import { routerReducer, RouterReducerState } from '@ngrx/router-store';
import { Action, ActionReducerMap, createFeatureSelector, MetaReducer } from '@ngrx/store';

import { environment } from '../../environments/environment';
import { AuthActionTypes } from './auth/auth.actions';
import { authReducer, AuthState } from './auth/auth.reducer';
import {
    certificationTypeReducer, CertificationTypeState
} from './entities/certification-type/store/certification-type.reducer';
import {
    checkRequirementsReducer, CheckRequirementsState
} from './entities/check-requirements/store/check-requirements.reducers';
import {
    clinicalRecordTypeReducer, ClinicalRecordTypeState
} from './entities/clinical-record-type/store/clinical-record-type.reducer';
import {
    countryCardReducer, CountryCardState
} from './entities/country-card/store/country-card.reducer';
import { countriesReducer, CountriesState } from './entities/country/store/country.reducers';
import {
    DocumentNotificationsState
} from './entities/document-notifications/document-notifications.state';
import {
    documentNotificationsReducer
} from './entities/document-notifications/store/document-notifications.reducer';
import { languageReducer, LanguageState } from './entities/language/store/language.reducer';
import {
    publicHealthRecordTypeReducer, PublicHealthRecordTypeState
} from './entities/public-health-record-type/store/public-health-record-type.reducer';
import { usersReducer, UsersState } from './entities/user/store/user.reducers';
import { layoutReducer, LayoutState } from './layout/state/layout.reducer';
import { loaderReducer, LoaderState } from './loader/loader.reducer';
import { RouterStateUrl } from './router/router.state';

export const reducers: ActionReducerMap<AppState> = {
  auth: authReducer,
  router: routerReducer,
  loader: loaderReducer,
  layout: layoutReducer,
  language: languageReducer,
  certificationType: certificationTypeReducer,
  publicHealthRecordType: publicHealthRecordTypeReducer,
  clinicalRecordType: clinicalRecordTypeReducer,
  users: usersReducer,
  checkRequirements: checkRequirementsReducer,
  countries: countriesReducer,
  countryCard: countryCardReducer,
  documentNotifications: documentNotificationsReducer
};


export function clearStateMetaReducer(reducer) {
  return (state, action) => {

    if (action.type === AuthActionTypes.Logout) {
      state = undefined;
    }

    return reducer(state, action);
  };
}

export const metaReducers: Array<MetaReducer<AppState, Action>> = [clearStateMetaReducer];


if (!environment.production) {
  metaReducers.unshift(storeFreeze);
}


export const selectAuthState = createFeatureSelector<AppState, AuthState>(
  'auth'
);

export const loaderSelector = createFeatureSelector<AppState, LoaderState>(
  'loader'
);

export const selectLayoutState = createFeatureSelector<AppState, LayoutState>(
  'layout'
);

export const selectLanguageState = createFeatureSelector<AppState, LanguageState>(
  'language'
);

export const selectCertificationTypeState = createFeatureSelector<AppState, CertificationTypeState>(
  'certificationType'
);

export const selectPublicHealthRecordTypeState = createFeatureSelector<AppState, PublicHealthRecordTypeState>(
  'publicHealthRecordType'
);

export const selectClinicalRecordTypeState = createFeatureSelector<AppState, ClinicalRecordTypeState>(
  'clinicalRecordType'
);

export const selectUsersState = createFeatureSelector<AppState, UsersState>(
  'users'
);

export const selectCheckRequirementsState = createFeatureSelector<AppState, CheckRequirementsState>(
  'checkRequirements'
);

export const selectCountriesState = createFeatureSelector<AppState, CountriesState>(
  'countries'
);


export const selectCountryCardsState = createFeatureSelector<AppState, CountryCardState>(
  'countryCard'
);

export const selectNotificationsState = createFeatureSelector<AppState, DocumentNotificationsState>(
  'documentNotifications'
);
export interface AppState {
  auth: AuthState;
  router: RouterReducerState<RouterStateUrl>;
  loader: LoaderState;
  layout: LayoutState;
  language: LanguageState;
  certificationType: CertificationTypeState;
  publicHealthRecordType: PublicHealthRecordTypeState;
  clinicalRecordType: ClinicalRecordTypeState;
  users: UsersState;
  checkRequirements: CheckRequirementsState;
  countries: CountriesState;
  countryCard: CountryCardState;
  documentNotifications: DocumentNotificationsState;
}
